module.exports = __webpack_public_path__ + "static/register-now.91d3b44b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/register-now.svg
// module id = 142
// module chunks = 168707334958949